export default "__VITE_ASSET__BEtSH9CL__"